import React, { Fragment, useState } from 'react';
import { IPostMessageSection } from './interfaces';
import { Button, CardContent, IconButton, Stack } from '@mui/material';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { InsertPhoto } from '@mui/icons-material';
import { MessageCard } from '../MessageCard';
import { MessageInput } from '../MessageInput';
import { useTranslation } from 'react-i18next';
import { useInDevMode } from '@hooks/useInDevMode';

export const PostMessageSection: React.FC<IPostMessageSection> = ({
  author,
  onMessagePost,
}): JSX.Element => {
  const [message, setMessage] = useState<string>('');
  const { t } = useTranslation();
  const inDevMode = useInDevMode();

  const handlePostMessage = (): void => {
    if (onMessagePost) {
      onMessagePost(message);
      setMessage('');
    }
  };

  return (
    <MessageCard>
      <CardContent>
        <MessageInput author={author} onChange={setMessage} value={message} />

        <Stack
          direction="row"
          gap="5px"
          sx={{
            mt: '10px',
          }}
        >
          {inDevMode && (
            <Fragment>
              <IconButton size="small">
                <PhotoCameraIcon
                  sx={{
                    width: '20px',
                    height: '20px',
                  }}
                />
              </IconButton>
              <IconButton size="small">
                <InsertPhoto
                  sx={{
                    width: '20px',
                    height: '20px',
                  }}
                />
              </IconButton>
              <IconButton size="small">
                <AttachFileIcon
                  sx={{
                    width: '20px',
                    height: '20px',
                  }}
                />
              </IconButton>
            </Fragment>
          )}

          <Button
            variant="contained"
            onClick={() => {
              handlePostMessage();
            }}
            size="small"
            sx={{ ml: 'auto', textTransform: 'unset', fontWeight: 'bold' }}
            disabled={message.length < 10}
          >
            {t('feed:buttons.postMessage')}
          </Button>
        </Stack>
      </CardContent>
    </MessageCard>
  );
};
